var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElevatorLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 522,
    height: 522,
    viewBox: "0 0 522 522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M513 517H9c-2.21 0-4-1.79-4-4V9c0-2.21 1.79-4 4-4h504c2.21 0 4 1.79 4 4v504c0 2.21-1.79 4-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M86 515V118.982A3.987 3.987 0 0 1 89.997 115h342.006a3.987 3.987 0 0 1 3.997 3.982V515M360.04 85H162c-2.207 0-4-1.74-4-3.883V38.883c0-2.143 1.793-3.883 4-3.883h198.04c2.206 0 4 1.74 4 3.883v42.234c0 2.143-1.794 3.883-4 3.883zM85.54 345.309H44.51a3.975 3.975 0 0 1-3.97-3.979V224.287a3.975 3.975 0 0 1 3.97-3.978h41.03v125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9530D",
    d: "M70.48 259.229a7.5 7.5 0 0 1-7.501 7.501 7.498 7.498 0 0 1-7.499-7.501 7.497 7.497 0 0 1 7.499-7.499 7.498 7.498 0 0 1 7.501 7.499zM70.48 305.588a7.5 7.5 0 0 1-15 0 7.5 7.5 0 1 1 15 0zM292.11 55H230a5 5 0 1 0 0 10h62.11a5 5 0 1 0 0-10zM253.5 115.23h10V517h-10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatorLine);
export default __webpack_public_path__ + "static/media/elevator-line.ef1f7bf70d9cd58cdb1f22c9c21747e2.svg";
export { ForwardRef as ReactComponent };